import { render, staticRenderFns } from "./ProdutoManage.vue?vue&type=template&id=591675e8&scoped=true"
import script from "./ProdutoManage.vue?vue&type=script&lang=js"
export * from "./ProdutoManage.vue?vue&type=script&lang=js"
import style0 from "./ProdutoManage.vue?vue&type=style&index=0&id=591675e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591675e8",
  null
  
)

export default component.exports